import React, { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { Form, Button } from 'react-bootstrap';
import api from '../../../services/api';
import useMedicos from '../../../hooks/useMedicos';

const NovoMedicoForm = () => {
  const { mutate } = useMedicos();
  const [novoMedico, setNovoMedico] = useState({
    nome: '',
    cpfusuario: '',
    especialidade: '',
    crm: '',
    rqe: '',
    tipoMedico: 'Externo',
  });

  const handleInserirMedico = useCallback(async () => {
    try {
      const { data } = await api.post('/medicos', novoMedico);
      mutate();
      toast.success(data.message);
    } catch (error) {
      toast.error('Falha ao cadastrar médico: ' + error.message);
    }
  }, [novoMedico, mutate]);

  const handleOnEnterPress = useCallback((e, next) => {
    if (e.key === 'Enter') {
      const nextElement = document.getElementById(next);
      if (nextElement) nextElement.select();
    }
  }, []);

  return (
    <div style={{ padding: 10 }}>
      <Form.Group controlId="formNome">
        <Form.Label className="m-0">Nome</Form.Label>
        <Form.Control
          type="text"
          value={novoMedico?.nome || ''}
          onChange={e => setNovoMedico({ ...novoMedico, nome: e.target.value })}
          onKeyUp={e => handleOnEnterPress(e, 'formCPF')}
        />
      </Form.Group>
      <Form.Group controlId="formCPF">
        <Form.Label className="m-0">CPF</Form.Label>
        <Form.Control
          type="text"
          value={novoMedico?.cpfusuario || ''}
          onChange={e =>
            setNovoMedico({
              ...novoMedico,
              cpfusuario: e.target.value,
            })
          }
          onKeyUp={e => handleOnEnterPress(e, 'formEspec')}
        />
      </Form.Group>
      <Form.Group controlId="formEspec">
        <Form.Label className="m-0">Especialidade</Form.Label>
        <Form.Control
          type="text"
          value={novoMedico?.especialidade || ''}
          onChange={e =>
            setNovoMedico({
              ...novoMedico,
              especialidade: e.target.value,
            })
          }
          onKeyUp={e => handleOnEnterPress(e, 'formCRM')}
        />
      </Form.Group>
      <Form.Group controlId="formCRM">
        <Form.Label className="m-0">CRM</Form.Label>
        <Form.Control
          type="text"
          value={novoMedico?.crm || ''}
          onChange={e =>
            setNovoMedico({
              ...novoMedico,
              crm: e.target.value,
            })
          }
          onKeyUp={e => handleOnEnterPress(e, 'formRQE')}
        />
      </Form.Group>
      <Form.Group controlId="formRQE">
        <Form.Label className="m-0">RQE</Form.Label>
        <Form.Control
          type="text"
          value={novoMedico?.rqe || ''}
          onChange={e => setNovoMedico({ ...novoMedico, rqe: e.target.value })}
          onKeyUp={e => handleOnEnterPress(e, 'btnInserir')}
        />
      </Form.Group>
      <div className="text-center">
        <Button
          id="btnInserir"
          variant="success"
          onClick={handleInserirMedico}
        >
          Gravar
        </Button>
      </div>
    </div>
  );
};

export default NovoMedicoForm;
